import React, { useMemo } from "react";
import { Divider } from "@mui/material";
import CustomDataTable from "@components/DataTable/CustomDataTable";
import { formatDateTime } from "@features/vessel-call/grid/utils.ts";
import { mapMovementServiceStatus } from "@features/vessel-call/vessel-call-status/MovementServices/preview/movementServiceStatus.mapper.ts";
import type { Movement } from "@services/movement-services/types";
import { useTranslation } from "react-i18next";

interface PastMovementsProps {
  rows?: Movement[];
  headers: { field: string; columnName: string; minWidth?: number }[];
  langBase: string;
  isLoading?: boolean;
  totalCount: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number, pageSize: number) => void;
}

const PastMovements: React.FC<PastMovementsProps> = ({
  rows = [],
  headers,
  langBase,
  totalCount,
  page,
  pageSize,
  onPageChange,
}) => {
  const { t } = useTranslation();

  const pagedRows = useMemo(() => {
    return rows.map((row) => {
      const statusMapping = mapMovementServiceStatus(String(row.status).toUpperCase());

      return {
        ...row,
        ats: row.ats ? formatDateTime(String(row.ats), "-") : "-",
        etc: row.etc ? formatDateTime(String(row.etc), "-") : "-",
        ets: row.ets ? formatDateTime(String(row.ets), "-") : "-",
        rta: row.rta ? formatDateTime(String(row.rta), "-") : "-",
        rtd: row.rtd ? formatDateTime(String(row.rtd), "-") : "-",
        rts: row.rts ? formatDateTime(String(row.rts), "-") : "-",
        badgeType: statusMapping.badgeType,
        status: t(statusMapping.translationKey, {
          defaultValue: row.status,
        }),
      };
    });
  }, [rows, t]);

  return (
    <div className="mt-8">
      <Divider sx={{ marginBottom: 4 }} />
      <CustomDataTable
        testId="past-movements-table"
        title={t(`${langBase}.past-movements-title`)}
        actionName={t(`${langBase}.addVesselCall`)}
        headers={headers}
        rows={pagedRows}
        page={page}
        pageSize={pageSize}
        totalCount={totalCount}
        canPreview={true}
        onPageChange={onPageChange}
        navigationLinkBase=""
        navigationParam="id"
        pageSizeOptions={[25, 50, 100]}
        hideFilters
        filters={[]}
        onApplyFilters={() => {}}
        onClearFilters={() => {}}
        availableFields={{}}
      />
    </div>
  );
};

export default PastMovements;
